import { ReactNode } from 'react';
import { Paper, Box } from '@mui/material';
import PokemonSprite from '../PokemonSprite';
import PokemonTypeChips from '../PokemonTypeChips';

interface AttackPokemonCardFrameProps {
  pokemonId: number;
  pokemonName: string;
  pictureUrl?: string;
  pokemonTypeIdList: number[];
  children: ReactNode;
  actions?: ReactNode;
  leftFooter?: ReactNode;
  backgroundColor?: string;
  border?: string;
  onClick?: () => void;
  hoverBackgroundColor?: string;
  cursor?: 'pointer' | 'default';
}

function AttackPokemonCardFrame({
  pokemonId,
  pokemonName,
  pictureUrl,
  pokemonTypeIdList,
  children,
  actions,
  leftFooter,
  backgroundColor = 'white',
  border = '1px solid #e0e0e0',
  onClick,
  hoverBackgroundColor,
  cursor,
}: AttackPokemonCardFrameProps) {
  return (
    <Paper
      sx={{
        p: 1.5,
        mb: 0,
        border,
        cursor: cursor || (onClick ? 'pointer' : 'default'),
        backgroundColor,
        '&:hover': hoverBackgroundColor
          ? {
              backgroundColor: hoverBackgroundColor,
            }
          : undefined,
      }}
      onClick={onClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flex: '1 1 240px', minWidth: 0 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <PokemonSprite pokemonId={pokemonId} pokemonName={pokemonName} pictureUrl={pictureUrl} />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <PokemonTypeChips pokemonTypeIdList={pokemonTypeIdList} />
              {leftFooter}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              gap: 1,
              flex: 1,
              minWidth: 0,
            }}
          >
            {children}
          </Box>
        </Box>
        {actions && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              ml: 'auto',
              flexShrink: 0,
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'flex-end', sm: 'flex-start' },
              mt: { xs: 0.5, sm: 0 },
            }}
            // 狭い幅では操作ボタンを折り返して右寄せにし、押しやすさを保つ
            onClick={(e) => e.stopPropagation()}
          >
            {actions}
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default AttackPokemonCardFrame;
